import { useEffect, useMemo, useState } from "react";

export const useBackgroundSelector = (selectedProduct, backgroundsData = {}, onSearchCommit) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [modal, setModal] = useState({ front: "" });

  const filteredBackgrounds = useMemo(() => {
    const currentGender = selectedProduct?.category === "men" ? "men" : "women";
    const backgrounds = Array.isArray(backgroundsData?.[currentGender])
      ? backgroundsData[currentGender]
      : [];

    if (!debouncedSearchTerm.trim()) return backgrounds;
    const lower = debouncedSearchTerm.toLowerCase();
    return backgrounds.filter((bg) =>
      String(bg?.name || bg?.title || "").toLowerCase().includes(lower),
    );
  }, [backgroundsData, debouncedSearchTerm, selectedProduct]);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 400);

    return () => {
      clearTimeout(timerId);
    };
  }, [searchTerm]);

  useEffect(() => {
    if (onSearchCommit) {
      onSearchCommit(debouncedSearchTerm);
    }
  }, [debouncedSearchTerm]);

  const onSearchChange = (e) => {
    setSearchTerm(e?.target?.value || "");
  };

  const openModal = (front) => setModal({ front: front || "" });
  const closeModal = () => setModal({ front: "" });

  return {
    searchTerm,
    onSearchChange,
    filteredBackgrounds,
    modal,
    openModal,
    closeModal,
  };
};
